export default {
      id: "Icon--filter-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--filter",
      toString: function () {
        return this.url;
      }
    }